/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".large-input__text[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:not([value=\"\"]):not(.has-label-visible){padding-bottom:26px}"];
export { styles as styles };
